import { render, staticRenderFns } from "./number.vue?vue&type=template&id=37a27750"
import script from "./number.vue?vue&type=script&lang=js"
export * from "./number.vue?vue&type=script&lang=js"
import style0 from "./number.vue?vue&type=style&index=0&id=37a27750&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports